//#region Imports

import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { NgClass } from '@angular/common';

//#endregion

@Component({
  selector: 'l-sortable-card',
  standalone: true,
  templateUrl: './sortable-card.component.html',
  imports: [CdkDragHandle, IconComponent, NgClass],
})
export class SortableCardComponent {

  //#region Inputs

  @Input()
  public active: boolean = false;

  @Input()
  public dragging: boolean = false;

  @Input()
  public ghost: boolean = false;

  @Input()
  public preview: boolean = false;

  @Input()
  public showDragHandle: boolean = true;

  @Input()
  public clickable: boolean = false;

  @Input()
  public dragHandleAriaLabel: string = 'Reordenar item';

  //#endregion

  //#region Outputs

  @Output()
  public readonly cardClick: EventEmitter<void> = new EventEmitter<void>();

  //#endregion

  //#region Public Methods

  public onCardClick(): void {
    if (this.clickable && !this.ghost) {
      this.cardClick.emit();
    }
  }

  //#endregion

}
